import { Badge, Collapse, List, useMediaQuery, useTheme } from "@mui/material";
import { RoomService, Circle } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../app/helpers";
import { ListItemLink } from "./list-item-link.component";
import { RootState } from "../../../app/rootReducer";
import { useRequestCount } from "../hooks/use-requests-count";

type P = {
  onToggleDrawerMobile: () => void;
  onToggleList: () => void;
  onCloseServiceList: () => void;
  isOpen: boolean;
  isToggled: boolean;
  mobileOpen: boolean;
};

export const ServiceDrawerList: React.FC<P> = ({
  onToggleDrawerMobile,
  onToggleList,
  onCloseServiceList,
  isOpen,
  isToggled,
  mobileOpen
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    userRoles: { isRequestAdmin },
    userInformation: {
      company: {
        meta: { activateBookingServices }
      }
    }
  } = useSelector((state: RootState) => state.login);
  const { requestCount } = useRequestCount({ isRequestAdmin });

  const { pathname } = globalThis.location; // full path
  const serviceItemLinkStyle =
    isToggled || pathname.includes("service") //  && !pathname.includes("equipment")
      ? {
          fontSize: "0.8rem",
          boxShadow: "inset 3px 0 0 0 " + theme.palette.primary.main
        }
      : undefined;
  const subItemLinkStyle = {
    height: "40px",
    fontSize: "0.8rem",
    boxShadow: "inset 3px 0 0 0 " + theme.palette.primary.main
  };

  const bookingRequestBadge = <Badge badgeContent={requestCount} color="primary" />;
  // if booking request count exists or order request count exists
  const serviceNotifyBadge =
    requestCount > 0 ? (
      <Circle data-testid="booking-request-notify-badge" color="primary" sx={{ fontSize: "8px" }} />
    ) : undefined;

  return (
    <List disablePadding sx={[isOpen ? { paddingLeft: "11%" } : { paddingLeft: 0 }]}>
      {isRequestAdmin && (
        <ListItemLink
          id="service"
          to={"/admin/service"}
          primary={t("Drawer_Services")}
          data-testid={"drawer-service-toggle"}
          icon={<RoomService />}
          onClick={e => {
            e.preventDefault();
            if (isToggled) return onCloseServiceList();
            onToggleList();
          }}
          navLinkStyleProps={serviceItemLinkStyle}
          isToggled={isToggled}
          badge={serviceNotifyBadge}
        />
      )}
      {/* sub item list */}
      {(isOpen || (mobileOpen && isMobile)) && (
        <Collapse in={isToggled}>
          <List
            onClick={() => onToggleDrawerMobile()}
            component="div"
            disablePadding
            data-testid="drawer-service-collapse-list"
          >
            {activateBookingServices && (
              <ListItemLink
                to={"/admin/service/management"}
                navLinkStyleProps={subItemLinkStyle}
                primary={t("Drawer_Sub_ServiceManagement")}
                data-testid="service-management"
              />
            )}
            <ListItemLink
              navLinkStyleProps={subItemLinkStyle}
              to={"/admin/service/bookings"}
              primary={t("Drawer_Sub_Bookings")}
              data-testid="service-bookings"
              badge={bookingRequestBadge}
            />
            {activateBookingServices && (
              <ListItemLink
                navLinkStyleProps={subItemLinkStyle}
                to={"/admin/service/orders"}
                primary={t("Drawer_Sub_Orders")}
                data-testid="service-orders"
              />
            )}
          </List>
        </Collapse>
      )}
    </List>
  );
};
